import React from "react";
import { Link } from "react-router-dom";
import { Star, ArrowLeft } from "lucide-react";
import Navigation from "../components/Navigation";
import Footer from "../components/Footer";
import WhatsAppFloat from "../components/WhatsAppFloat";
import { useSite } from "../lib/SiteContext";

const ReviewsPage = () => {
  const { content } = useSite();
  const r = content?.reviews || {};
  const items = r.items || [];

  return (
    <div data-testid="reviews-page">
      <Navigation />

      <section className="pt-32 pb-12 bg-primary text-white">
        <div className="container-x">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-sm text-white/70 hover:text-sand mb-6"
            data-testid="back-home"
          >
            <ArrowLeft size={14} /> Back home
          </Link>
          <div className="overline text-sand mb-4">Guest Reviews</div>
          <h1 className="font-serif text-5xl sm:text-6xl lg:text-7xl tracking-tight leading-[0.95] text-balance">
            {items.length} five-star reviews
          </h1>
          <p className="mt-6 text-white/80 max-w-2xl leading-relaxed">
            Every review here is from a real guest who sailed with us. They&rsquo;re shown exactly as they were written —
            including the ones in their original language with our translations.
          </p>
          <div className="mt-8 flex items-center gap-3">
            {[1, 2, 3, 4, 5].map((i) => (
              <Star key={i} size={20} className="fill-sand text-sand" />
            ))}
            <span className="text-sm text-white/75">
              {Number(r.rating || 5).toFixed(1)} average rating
            </span>
          </div>
        </div>
      </section>

      <section className="py-16 md:py-24 bg-background">
        <div className="container-x">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="all-reviews">
            {items.map((rev, i) => (
              <figure
                key={i}
                className="bg-white border border-border p-7 flex flex-col"
                data-testid={`all-review-${i}`}
              >
                <div className="flex gap-1 mb-4">
                  {[1, 2, 3, 4, 5].map((s) => (
                    <Star key={s} size={13} className="fill-secondary text-secondary" />
                  ))}
                </div>
                <blockquote className="font-serif text-base md:text-lg text-primary leading-snug mb-5 flex-1">
                  &ldquo;{rev.text}&rdquo;
                </blockquote>
                <figcaption className="border-t border-border pt-4">
                  <div className="text-sm font-medium text-primary">{rev.name}</div>
                  <div className="text-xs text-muted-foreground tracking-wider uppercase mt-0.5">
                    {rev.date || rev.country}
                  </div>
                  {rev.note && (
                    <div className="text-[11px] italic text-muted-foreground mt-1">{rev.note}</div>
                  )}
                </figcaption>
              </figure>
            ))}
          </div>

          <div className="mt-16 flex flex-col sm:flex-row justify-center gap-4">
            <Link to="/book" className="btn-primary" data-testid="reviews-book-cta">
              Book your day at sea
            </Link>
            <Link to="/" className="btn-outline">
              Back home
            </Link>
          </div>
        </div>
      </section>

      <Footer />
      <WhatsAppFloat />
    </div>
  );
};

export default ReviewsPage;
